module.exports = __webpack_public_path__ + "img/add-fabric.95949038.svg";